import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sgc-card" }
const _hoisted_2 = { class: "sgc-header" }
const _hoisted_3 = { class: "sgc-actions" }
const _hoisted_4 = {
  key: 0,
  class: "sgc-empty"
}
const _hoisted_5 = {
  key: 1,
  class: "sgc-empty"
}
const _hoisted_6 = {
  key: 2,
  class: "sgc-chart-area"
}
const _hoisted_7 = { class: "sgc-y-axis" }
const _hoisted_8 = { class: "sgc-chart" }
const _hoisted_9 = { class: "sgc-bar-wrapper" }
const _hoisted_10 = { class: "sgc-tooltip" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "sgc-modal-header" }
const _hoisted_13 = { id: "sgcModalTitle" }
const _hoisted_14 = { class: "sgc-modal-actions" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = { class: "sgc-modal-chart-area" }
const _hoisted_19 = { class: "sgc-y-axis modal-y-axis" }
const _hoisted_20 = { class: "sgc-modal-chart" }
const _hoisted_21 = { class: "sgc-modal-bar-wrapper" }
const _hoisted_22 = { class: "sgc-tooltip" }
const _hoisted_23 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridLoading = _resolveComponent("GridLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t("dashboard.productWiseSgcConsumptionTitle")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("dashboard.productWiseSgcConsumptionSubtitle", { unit: _ctx.unitLabel })), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass({ active: _ctx.selectedMeasure === 'average' }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMeasure('average')))
        }, _toDisplayString(_ctx.$t("dashboard.average")), 3),
        _createElementVNode("button", {
          class: _normalizeClass({ active: _ctx.selectedMeasure === 'median' }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMeasure('median')))
        }, _toDisplayString(_ctx.$t("dashboard.median")), 3)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_GridLoading, {
            infoText: _ctx.$t('dashboard.loading')
          }, null, 8, ["infoText"])
        ]))
      : (!_ctx.products.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yTicks, (tick) => {
                return (_openBlock(), _createElementBlock("span", { key: tick }, _toDisplayString(tick), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yTicks, (tick) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'grid-' + tick,
                  class: "sgc-grid-line"
                }))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tileProducts, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.productType,
                  class: "sgc-bar-item"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "sgc-column-bar",
                      style: _normalizeStyle({ height: _ctx.getBarHeight(item.value) + '%' })
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("strong", null, _toDisplayString(item.productType), 1),
                        _createElementVNode("span", null, [
                          _cache[12] || (_cache[12] = _createElementVNode("i", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatValue(item.value)), 1)
                        ])
                      ])
                    ], 4)
                  ]),
                  _createElementVNode("div", {
                    class: "sgc-x-label",
                    title: item.productType
                  }, _toDisplayString(item.productType), 9, _hoisted_11)
                ]))
              }), 128))
            ])
          ])),
    (_ctx.sortedProducts.length > 5)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          ref: "expandBtn",
          class: "show-all",
          tabindex: "0",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
          onKeydown: [
            _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)), ["enter"])),
            _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)), ["prevent"]), ["space"]))
          ]
        }, [
          _cache[13] || (_cache[13] = _createElementVNode("i", {
            class: "fa fa-arrows-alt",
            "aria-hidden": "true"
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.showAllProducts", { count: _ctx.sortedProducts.length })), 1)
        ], 544))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "sgc-modal-backdrop",
          onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", {
            ref: "modal",
            class: "sgc-modal",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "sgcModalTitle",
            tabindex: "-1",
            onKeydown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onModalKeydown && _ctx.onModalKeydown(...args)))
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t("dashboard.productWiseSgcConsumptionTitle")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("dashboard.allProducts", { count: _ctx.sortedProducts.length })) + " · " + _toDisplayString(_ctx.selectedMeasureLabel), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: _normalizeClass({ active: _ctx.selectedMeasure === 'average' }),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setMeasure('average')))
                }, _toDisplayString(_ctx.$t("dashboard.average")), 3),
                _createElementVNode("button", {
                  class: _normalizeClass({ active: _ctx.selectedMeasure === 'median' }),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setMeasure('median')))
                }, _toDisplayString(_ctx.$t("dashboard.median")), 3),
                _createElementVNode("button", {
                  class: "nav-btn",
                  disabled: !_ctx.canGoPrevious,
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.previousModalProducts && _ctx.previousModalProducts(...args)))
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
                ]))], 8, _hoisted_15),
                _createElementVNode("button", {
                  class: "nav-btn",
                  disabled: !_ctx.canGoNext,
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextModalProducts && _ctx.nextModalProducts(...args)))
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
                ]))], 8, _hoisted_16),
                _createElementVNode("button", {
                  class: "modal-close-btn",
                  "aria-label": _ctx.$t('popup.close'),
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))], 8, _hoisted_17)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalYTicks, (tick) => {
                  return (_openBlock(), _createElementBlock("span", { key: tick }, _toDisplayString(tick), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalYTicks, (tick) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'modal-grid-' + tick,
                    class: "sgc-grid-line"
                  }))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalVisibleProducts, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.productType,
                    class: "sgc-modal-bar-item"
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", {
                        class: "sgc-column-bar",
                        style: _normalizeStyle({ height: _ctx.getModalBarHeight(item.value) + '%' })
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("strong", null, _toDisplayString(item.productType), 1),
                          _createElementVNode("span", null, [
                            _cache[17] || (_cache[17] = _createElementVNode("i", null, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.formatValue(item.value)), 1)
                          ])
                        ])
                      ], 4)
                    ]),
                    _createElementVNode("div", {
                      class: "sgc-x-label",
                      title: item.productType
                    }, _toDisplayString(item.productType), 9, _hoisted_23)
                  ]))
                }), 128))
              ])
            ])
          ], 544)
        ]))
      : _createCommentVNode("", true)
  ]))
}